import clsx from 'clsx';
import { ComponentProps } from 'lib/component-props';

export function getComponentCss(component: ComponentProps) {
  return clsx('component', component.params?.Styles as string);
}
